import { render, staticRenderFns } from "./sans.vue?vue&type=template&id=455e77d9&"
import script from "./sans.vue?vue&type=script&lang=js&"
export * from "./sans.vue?vue&type=script&lang=js&"
import style0 from "./sans.vue?vue&type=style&index=0&id=455e77d9&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports